// LanguageSwitcher.js
import React from "react";
import { useTranslation } from "react-i18next";
import { MenuItem, Select } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event) => {
    const selectedLang = event.target.value;
    if (selectedLang === currentLang) return;

    // Replace the current language prefix in the URL
    const segments = location.pathname.split("/");
    segments[1] = selectedLang;

    const newPath = segments.join("/") || "/";
    const searchParams = location.search;

    // Set global cookie to share language across subdomains
    
    navigate(newPath + searchParams);
    i18n.changeLanguage(selectedLang);
    document.cookie = `i18next=${selectedLang}; path=/; domain=.copysa.ir; max-age=31536000`;
  };


  return (
    <Select
      value={currentLang}
      onChange={handleChange}
      size="small"
      sx={{ minWidth: 100, color: "white", borderColor: "white" }}
    >
      <MenuItem value="fa">فارسی</MenuItem>
      <MenuItem value="en">English</MenuItem>
    </Select>
  );
};

export default LanguageSwitcher;
